import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function apiCall(
	searchTerm: string | undefined,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseMenuPlanner[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/MenuPlanner/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	return axios
		.get(url, {
			params: params,
		})
		.toOptionalMapped((x) => x.data.menuPlanners);
}

interface Parameter {
	SearchTerm?: string;
	ShowOnlyDeleted: boolean;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	menuPlanners: ResponseMenuPlanner[];
};

export type ResponseMenuPlanner = {
	id: string;
	description: string;
};
